import React from 'react'
import { Switch, Route, Redirect, useHistory, useLocation } from 'react-router-dom'

import Create from './pages/create'
import List from './pages/list'
import Edit from './pages/edit'
import Preview from './pages/preview'

/**
 *
 */
const Campaigns = (): JSX.Element => {
    const { pathname } = useLocation()
    const history = useHistory()

    const appPath = '/campaigns'
    const basePath = `${pathname.split(appPath)[0]}${appPath}`

    const goToListPage = () => {
        history.push(`${basePath}`)
    }

    const goToCreatePage = () => {
        history.push(`${basePath}/create`)
    }
    const goToPreviewPage = (id) => {
        history.push(`${basePath}/${id}/preview`)
    }

    const goToEditPage = (id) => {
        if (id) history.push(`${basePath}/${id}/edit`)
    }

    const goToPaymentFailedPage = (id) => {
        if (id) history.push(`${basePath}/${id}/edit?payment-failed`)
    }

    return <div>
        <Switch>
            <Route
                path={`${basePath}/create`}
                render={() => (
                    <Create goToListPage={ goToListPage }/>
                )}
            />
            <Route
                path={`${basePath}/:id/preview`}
                render={() => (
                    <Preview
                        onClickSubmitPaymentFailed={goToPaymentFailedPage}
                        onClickEdit={goToEditPage}
                        onGoBack={goToListPage}
                    />
                )}
            />
            <Route
                path={`${basePath}/:id/edit`}
                render={() => (
                    <Edit goToListPage={ goToListPage }/>
                )}
            />
            <Route
                path={basePath}
                render={() => (
                    <List
                        onClickAddNew={goToCreatePage}
                        onClickPreview={goToPreviewPage}
                    />
                )}
            />
            <Route
                path='/'
                render={() => <Redirect to={`${basePath}`} />}
            />
        </Switch>
    </div>
}

export default Campaigns
